module.exports = __webpack_public_path__ + "img/404-cloud-left.2a39da5a.png";